module.exports = __webpack_public_path__ + "assets/img/KeyReport_Noig.77cf6dcc-ps.jpg";